require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2006-05-18-uru-undead.json") })
        }
      }, "path---articles-2006-05-18-uru-undead");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2006-05-18-uru-undead!./.cache/json/articles-2006-05-18-uru-undead.json
// module id = 464
// module chunks = 231608221292675